import React from 'react';
import { PaymentCard } from '../../requests/caipirinha-api/interfaces/order.interface';
import { toBRL } from '../../utils/money.util';

type CreditCardWithInterestProps = {
  paymentCard: PaymentCard;
};

const CreditCardWithInterest: React.FC<CreditCardWithInterestProps> = (props) => {
  const { paymentCard: { simulated, installments } } = props;
  const totalInstallmentWithInterest = `${installments}x de ${toBRL(simulated?.installmentValue || 0)}`;
  const fees = `IOF ${toBRL(simulated?.taxValue || 0)} | CET ${simulated?.cet || 0}%`;
  const totalWithInterest = toBRL(simulated?.totalAmount || 0);

  return (
    <>
      <div className='details'>
        <p className='medium' data-cy='total-with-interest-title'>Total com juros*</p>
        <strong data-cy='total-installment-with-interest'>{totalInstallmentWithInterest}</strong>
      </div>
      <div className='details'>
        <p className='small' data-cy='fees-value-information'>{fees}</p>
        <p className='medium' data-cy='total-amount'>{totalWithInterest}</p>
      </div>

      <p
        className='information-text'
        data-cy='interest-payment-information'>
          *Os juros serão cobrados pelo banco.
      </p>
    </>
  );
};

export default CreditCardWithInterest;
